import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_mb-3" }
const _hoisted_2 = { class: "_mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-field__readonly _mt-1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_ctx.model)
    ? (_openBlock(), _createBlock(_component_modal_box, {
        key: 0,
        "is-visible": true,
        title: _ctx.Resources.AccountSettings.ChangeEmailTitle,
        icon: "user-cog",
        width: "narrow"
      }, {
        actions: _withCtx(() => [
          _createElementVNode("a", {
            href: "",
            class: "gfu-link gfu-link--accent gfu-link--inline _mb-1",
            onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
            "data-qa": "modal-button:Cancel"
          }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--wide gfu-btn--compact _ml-3 _mt-1",
            onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => ($options.submit && $options.submit(...args)), ["prevent"])),
            "data-qa": "modal-button:Confirm"
          }, _toDisplayString(_ctx.Resources.Common.ModalConfirmButton), 1 /* TEXT */)
        ]),
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.Resources.AccountSettings.ChangeEmailInfoText), 1 /* TEXT */),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.Resources.AccountSettings.ChangeEmailGoogleFbWarningText), 1 /* TEXT */),
            _createVNode(_component_text_field, {
              "model-value": $props.email,
              "display-name": _ctx.Resources.AccountSettings.ChangeEmailCurrentEmailFieldLabel,
              "read-only": true,
              "data-qa": "modal-field:CurrentEmail"
            }, null, 8 /* PROPS */, ["model-value", "display-name"]),
            ($props.pendingNewEmail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.AccountSettings.ChangeEmailPendingChangeInfoText, $props.pendingNewEmail)) + " ", 1 /* TEXT */),
                  _createElementVNode("a", {
                    href: "",
                    class: "gfu-link gfu-link--accent _ml-1",
                    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.revertEmailChange && $options.revertEmailChange(...args)), ["prevent"])),
                    "data-qa": "modal-button:Revert"
                  }, _toDisplayString(_ctx.Resources.AccountSettings.ChangeEmailRevertButton), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_text_field, {
              modelValue: _ctx.model.newEmail,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.model.newEmail) = $event)),
              "display-name": _ctx.Resources.AccountSettings.ChangeEmailNewEmailFieldLabel,
              name: "model.newEmail",
              onKeyup: _withKeys(_withModifiers($options.submit, ["prevent","stop"]), ["enter"]),
              "data-qa": "modal-field:Email"
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "onKeyup"]),
            _createElementVNode("p", null, _toDisplayString(_ctx.Resources.AccountSettings.ChangeEmailPasswordInfoText), 1 /* TEXT */),
            _createVNode(_component_text_field, {
              modelValue: _ctx.model.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.model.password) = $event)),
              "display-name": _ctx.Resources.AccountSettings.ChangeEmailPasswordFieldLabel,
              type: "password",
              name: "model.password",
              onKeyup: _withKeys(_withModifiers($options.submit, ["prevent","stop"]), ["enter"]),
              "data-qa": "modal-field:Password"
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "onKeyup"])
          ]),
          _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title"]))
    : _createCommentVNode("v-if", true)
}